import CompanyIndexSectionPage from '../company_index_section_page';
import companyIndexPageStateManager from '../company_index_section_page_state_manager';

export default function(store) {
  return {
    path: '/company',
    component: CompanyIndexSectionPage,
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: companyIndexPageStateManager(store)
  };
}



// WEBPACK FOOTER //
// ./src/views/containers/pages/mic/company_index_section_page/routes/company_index_route.js